import React, { useMemo, useState, useCallback } from "react";
import { Offcanvas, Button, Col } from "react-bootstrap";
import { Upload, message } from "antd";
import { useTranslation } from "react-i18next";
import { ImagePlus } from "lucide-react";
import { uploadProductImages } from "@services/axios";
const { Dragger } = Upload;
const FormAddImage = ({ productId, loadAlbum }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  // Local image state
  const [images, setImages] = useState([]);

  // Convert to Upload component fileList
  const fileList = useMemo(
    () =>
      images.map((img) => ({
        uid: img.uid,
        name: img.name,
        status: "done",
        url: img.preview,
        originFileObj: img.file,
      })),
    [images]
  );

  const handleChange = useCallback(
    ({ fileList }) =>
      setImages(
        fileList.map((f) => {
          const existing = images.find((v) => v.uid === f.uid);
          const origin = f.originFileObj;

          const preview =
            existing?.preview ||
            f.url ||
            (origin instanceof File ? URL.createObjectURL(origin) : undefined);

          return {
            uid: f.uid,
            name: f.name,
            file: origin || existing?.file,
            preview,
          };
        })
      ),
    [images]
  );
  const handleRemove = useCallback(
    (file) => {
      const found = images.find((v) => v.uid === file.uid);
      if (found?.preview?.startsWith("blob:")) {
        URL.revokeObjectURL(found.preview);
      }
      return true;
    },
    [images]
  );

  const handlePreview = useCallback(
    (file) => {
      const found = images.find((v) => v.uid === file.uid);
      const url = file.url || found?.preview;

      if (url) window.open(url, "_blank");
      else if (file.originFileObj) {
        window.open(URL.createObjectURL(file.originFileObj), "_blank");
      }
    },
    [images]
  );

  const handleSave = async () => {
    setLoading(true);
    const endpoint = `/product/album/${productId}/upload`;
    const response = await uploadProductImages(endpoint, images);
    if (response?.request?.code === 200) {
      message.success(t("photos_saved_success"));
      setImages([]);
      await loadAlbum();
    } else {
      message.error(response?.result?.message);
    }

    setLoading(false);
  };

  return (
    <>
      <Button className="btn-blue" onClick={handleShow}>
        {t("add_photos")}
      </Button>

      <Offcanvas show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{t("add_photos")}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Dragger
            accept="image/*"
            multiple
            listType="picture-card"
            beforeUpload={() => false}
            fileList={fileList}
            onChange={handleChange}
            onRemove={handleRemove}
            onPreview={handlePreview}
            style={{ background: "#fff" }}
          >
            <div
              style={{
                height: 120,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="text-dark d-flex flex-column align-items-center p-2">
                <ImagePlus size={24} strokeWidth={1.5} />
                <div className="fs-6 fw-bold my-2">{t("drag_photos")}</div>
                <p className="fs-6 text-decoration-underline mb-0">
                  {t("download_from_device")}
                </p>
              </div>
            </div>
          </Dragger>
          <div className="mt-3 d-flex justify-content-center gap-2">
            <button
              type="button"
              className="btn-lg fs-6 py-3 rounded-5 btn-blue w-100"
              onClick={handleSave}
            >
              {loading ? (
                <span
                  as="span"
                  className="spinner-border spinner-border-sm m-1 "
                ></span>
              ) : (
                t("save")
              )}
            </button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default FormAddImage;
